import { useLocation } from "@reach/router"
import useSiteMetadata from "@utils/useSiteMetadata"

export const setLangCookie = () => {
  document.cookie = `lang=true; domain=fastly.com; path=/;`

  // remove previously set cookie on www.fastly.com - this should be set on fastly.com so it works across subdomains such as developer.fastly.com
  document.cookie = "lang=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.www.fastly.com; path=/;"
}

export default function LanguageMenu({ links }) {
  const location = useLocation()
  const { localesRegex } = useSiteMetadata()
  const currentRegex = new RegExp(localesRegex)
  const currentPath = (location.pathname + location.search).replace(currentRegex, "/")

  const langLinks = links.map((link) => {
    const pathLink = link.url === "/" ? location.origin + currentPath : location.origin + link.url + currentPath

    return (
      <li className="leaf" key={link.id}>
        <a href={pathLink} onClick={setLangCookie}>
          {link.name}
        </a>
      </li>
    )
  })
  return <ul className="menu">{langLinks}</ul>
}
